import { Button, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const OfferEventCampaign = ({setActiveStep}) => {
  return (
    <div className='flex flex-col gap-1'>
      <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',    textAlign: 'justify',    lineHeight: 1.6  }}>
        Please share your offer, event and campaign details if you would like them to be shared with NPOs.  
        Please fill one applicable form for each offer/ event/ campaign. You can login anytime to fill these forms and submit. 
        Our GuideStar India team will review and process your request. If you need any assistance or clarification, 
        <Link to='/contact' className='text-blue-600'> contact us</Link> 

        
      </Typography>
      <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',    textAlign: 'justify',    lineHeight: 1.6  }}>
       

        Offer: <a href="https://forms.gle/jsyqUhG4zP6HHMSS7" target='_blank' rel='noreferrer' className='text-blue-600'>https://forms.gle/jsyqUhG4zP6HHMSS7</a> <br />
        
      </Typography>
      <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',    textAlign: 'justify',    lineHeight: 1.6  }}>
        
        Events: <a href="https://forms.gle/QLhkVbUsUQYBa2bg6" target='_blank' rel='noreferrer' className='text-blue-600'>https://forms.gle/QLhkVbUsUQYBa2bg6</a>  <br />
      </Typography>
      <Typography variant='h3'  sx={{    fontSize: '15px',    fontWeight: 400,    margin: '0 0 10px 0',    textAlign: 'justify',    lineHeight: 1.6  }}>
        
        Campaign: <a href="https://forms.gle/TEHGGdaeNy5ZzNwa9" target='_blank' rel='noreferrer' className='text-blue-600'>https://forms.gle/TEHGGdaeNy5ZzNwa9</a>  <br /> 
      </Typography>



      <div className='flex justify-end'>
          <div className='flex gap-[20px]'>
            <Button onClick={() => setActiveStep(2)}  variant='contained' sx={{backgroundColor:'#004878' , color:'white' , padding:'5px 30px' , borderRadius:'20px', fontWeight:600 , textTransform:'inherit' , letterSpacing:'-.5px' , fontSize:'14px' , '&:hover':{backgroundColor:'#004878'}}}>Register Offer/ Event</Button>
          </div>
      </div>
    </div>
  )
}

export default OfferEventCampaign